/**
 * K线图收盘价折线
 */
import {
  LINE_TYPE
} from '../../viewmodel/setting.js';
import KLineState from '../kline'
import Util, {mergeModelData, curryFun} from '../../util/index.js';
const model = {
  close_px: {
    Type: Object,
    Default: () => ({})
  },
  special_close_px: {
    Type: Object,
    Default: () => ({})
  }
};
export default class KLineCloseLineState extends KLineState {
  constructor({data, ...rest}) {
    super({...rest, data: mergeModelData(model, data)});
  }
  // 计算纵轴范围
  _calcRange() {
    const {close_px,special_close_px} = this.state.data;
    const { business_type } = this.store.state
    this.calcRange({data: business_type === '1.0'?special_close_px:close_px, targetKey: 'value', isAdditional: true});
    this.baseValue = (this.maxValue + this.minValue) / 2;
  }
  // 计算各个点的Y轴坐标
  _calcAxis() {
    const {close_px,special_close_px} = this.state.data;
    const { business_type } = this.store.state
    const curryCalcAxis = curryFun(this.calcAxis, this, {
      targetKey: 'value',
      sourceKey: 'lineY',
      isAdditional: true,
    });
    curryCalcAxis({data: business_type === '1.0'?special_close_px:close_px});
  }
  _drawMain() {
    const {
      left,
      bottom,
      top,
      height,
    } = this.availArea;
    const {close_px,special_close_px} = this.state.data;
    const { business_type } = this.store.state
    const {closeLine: closeOption} = this.option.KLine.closePx;
    const {LINE} = LINE_TYPE;
    this._drawLine(LINE, business_type === '1.0'?special_close_px:close_px, left, bottom, closeOption.lineWidth, closeOption.color);
  }
  _calcCursorAxis(index) {
    const {kline, start, close_px,special_close_px} = this.state.data;
    const { business_type } = this.store.state
    /*** 绘制Y轴标签 ***/
    const data = business_type === '1.0'?special_close_px[index]:close_px[index];
    if (data) {
      const text = data.value;
      const y = data.lineY;
      return {text, y}
    }
  }
  _drawTitle() {
    const { business_type } = this.store.state
    const ctx2 = this.curContext;
    const {current, sealObj} = this.state.data;
    const {height, top, baseSize} = this.state;
    const {ratioFixed} = sealObj;
    const {baseLine} = this.option.MainContext.title;
    const baseLineY = top + height * baseLine;
    let {left} = this.availArea;
    const data = business_type === '1.0'?this.state.data.special_close_px:this.state.data.close_px
    const {
      sizeRatio,
      fontFamily,
      color,
      space
    } = this.option.KLine.closePx;
    ctx2.font = sizeRatio * baseSize * this.dpr + 'px ' + fontFamily;
    ctx2.fillStyle = color;
    ctx2.textAlign = 'left';
    ctx2.textBaseline = 'middle';
    ctx2.beginPath();
    const item = data[current];
    if (Util.isDef(item) && Util.isValidNumber(item.value)) {
      const text = '收盘价: ' + item.value.toFixed(ratioFixed);
      const textWidth = ctx2.measureText(text).width;
      ctx2.fillText(text, left, baseLineY);
      left += textWidth;
    } else {
      const text = '收盘价: -';
      const textWidth = ctx2.measureText(text).width;
      ctx2.fillText(text, left, baseLineY);
      left += textWidth;
    }
    left += space * this.dpr;
  }
}
